<template>
  <div class="panel-in-tab">
    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <div style="height: 10px"></div>
      </template>
      <el-table
        :data="tableData"
        :height="maxTableHeight + 42"
        v-loading="tableData === null"
        border
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
      >
        <el-table-column
          label="平台名称"
          prop="platformName"
          width="120px"
        ></el-table-column>
        <el-table-column label="店铺名称" prop="storeName"></el-table-column>
        <el-table-column
          label="店铺简称"
          prop="shortName"
          width="160px"
        >
        </el-table-column>
        <el-table-column label="是否参与清仓" prop="reportAble" width="160px">
          <template slot-scope="scope">
            <el-select
              v-if="scope.row.flag"
              v-model="scope.row.reportAble"
              size="mini"
              placeholder="请选择"
            >
              <el-option
                v-for="item in reportOptions"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
            <span v-else>{{ scope.row.reportAble }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="更新人"
          prop="updatedPerson"
          width="120px"
        ></el-table-column>
        <el-table-column
          label="更新时间"
          prop="updatedDate"
        ></el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-link type="primary" :underline="false" @click="updateAdd(scope.row)">
              {{ !scope.row.flag ? "编辑" : "保存" }}
            </el-link>
            <el-link
              type="warning"
              :underline="false"
              @click="cancel"
              v-if="scope.row.flag"
              style="margin-left: 10px"
            >
              取消
            </el-link>
          </template>
        </el-table-column>
      </el-table>
    </table-panel>
  </div>
</template>

<script>
import axios from '@/utils/axiosInstance'
import tableMixin from '@/utils/tableMixin'

export default {
  mixins: [tableMixin],
  data() {
    return {
      tableData: null,
      loading: false,
      reportOptions: ["是", "否"],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [],
        orderList: [],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    // 编辑/保存
    updateAdd(row) {
      row.flag = !row.flag;
      if (!row.flag) {
        //保存
        this.handleSelectChange(row)
      }
    },
    // 取消
    cancel() {
      this.init();
    },
    async init() {
      this.loading = true;
      let currencyForm = JSON.parse(JSON.stringify(this.currencyForm))
      currencyForm.reportCode = 'clearStockStoreConfigList'
      axios.post(`/ec-pc-api/custom/reports/data/clearStockStoreConfigList`, currencyForm).then(res => {
        if (res.code == 200) {
          res.data.list.forEach(v => {
            v.flag = false
          });
          this.tableData = res.data.list
        } else {
          this.tableData = [];
        }
      }).finally(() => {
        this.loading = false
      });
    },
    async handleSelectChange(row) {
      let data = {
        dataId: row.dataId,
        reportAble: row.reportAble,
        storeCode: row.storeCode
      };
      this.$q.clearanceManagement
        .storeReportUpdate({ data })
        .then(res => {
          if (res.success) {
            this.$message.success("修改成功");
          } else {
            this.$message.fail("修改失败");
          }
        })
        .finally(_ => {
          this.init();
        });
    }
  }
};
</script>

<style lang="stylus" scoped>
.panel-in-tab
  >>> .search-outer>div
    padding 0

>>> .el-input--mini .el-input__inner
  width 64px
</style>
